
const BASE_TIME = "2021-01-01";
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { Options, Vue } from "vue-class-component";
import { compare, dateConversion, getLocalProject } from "@/utils";
import * as echarts from "echarts";
import {
  dispatchDeepScene,
  dispatchDeepSceneOld,
  dispatchGetNzmMemoryStackAll,
  dispatchDeepFind,
  dispatchDeepSceneOptions,
  dispatcheepMemreport,
  dispatchPkgResourceDate,
  dispatchPkgResourceDevice,
  dispatchPkgResourceScenes,
  dispatchPkgResourceList,
  dispatchPkgResourceListOld,
  dispatchPkgResourceStack,
  dispatchPkgTypeTable,
  dispatchPkgResourceStackOld,
  dispatchPkgResourceSum,
  dispatchPkgTypeRate,
  dispatchPkgResourceTrend,
  dispatchPkgAssetStack,
  dispatchPkgAssetStackFind,
  dispatchPkgAssetTrend,
  dispatchPkgStructStack,
  dispatchPkgStructTrend,
  dispatchPkgMapStructStack,
  dispatchPkgMapStructTrend,
  dispatchPkgMapStructStackOption,
  dispatchPkgResourceListThreadOld,
  dispatchAbnormalTrend,
  dispatchPkgResourceAbnormalList,
  dispatchPkgResourceAbnormalFile,
  dispatchPutAabnormalResourceList,
  dispatchPkgAssetType,
  dispatchPutAssetStack,
  dispatchPkgMapStructStackList,
} from "@/store/performance/actions";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import { store } from "@/store";
import {
  readDeepScene,
  readGetNzmMemoryStackAll,
  readDeepFind,
  readDeepSceneOld,
  readDeepSceneVedio,
  readDeepSceneOldVedio,
  readDeepSceneOptions,
  readDeepSceneRport,
  readGetPkgResourceDate,
  readGetPkgResourceDevice,
  readGetPkgResourceScene,
  readGetPkgResourceList,
  readGetPkgResourceListOld,
  readGetPkgResourceStack,
  readGetPkgResourceTable,
  readGetPkgResourceStackOld,
  readGetPkgResourceSum,
  readGetPkgResourceRate,
  readGetPkgResourceTrend,
  readGetPkgAssetStack,
  readGetPkgAssetStackFind,
  readGetPkgAssetTrend,
  readGetPkgStructStack,
  readGetPkgStructTrend,
  readGetPkgMapStructStack,
  readGetPkgMapStructStackOption,
  readGetPkgMapStructTrend,
  readGetPkgResourceListThreadOld,
  readGetPkgAbnormaTrend,
  readGetPkgAssetType,
  readGetPkgMapStructStackList,
} from "@/store/performance/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import { dispatchGetProjectScenes } from "@/store/project/actions";
import { ElMessage } from "element-plus";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
import { readSimpleScriptList } from "@/store/task/getters";
import { color } from "html2canvas/dist/types/css/types/color";
import { version } from "echarts/core";
import fileSaver from "file-saver";
export default class ProjectOverview extends Vue {
  public localProject = Number(getLocalProject());

  public form = {
    date: "",
    device: "",
    scene: "",
    idTest: "",
    pick: "",
    dateOld: "",
    idTest_old: "",
    idTest_thread_old: "",
    secondPick: "",
    thireadPick: [],
    date_thired_old: "",
  };
  public get pkg_type() {
    return readGetPkgAssetType(store);
  }
  public async putPkg(row) {
    await dispatchPutAssetStack(store, {
      project: this.localProject,
      id: row.id,
      is_ignore: row.is_ignore ? "1" : "0",
    });
    this.pkgChange(false);
  }
  public type = "";
  public is_ignoreChange() {
    this.maxChange(true);
  }
  public async exportMax() {
    let responseContent = await dispatchPkgResourceAbnormalFile(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest_thread_old),

      type: "MaxFile",
      is_ignore: this.big_is_ignore,
    });
    const blob = new Blob([responseContent], {
      type: "text/plain;charset=utf-8",
    });

    // 使用 FileSaver.js 保存 Blob 对象为文件
    fileSaver(blob, "超大资源.txt");
  }
  public async exportVedio() {
    let responseContent = await dispatchPkgResourceAbnormalFile(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest_thread_old),

      type: "MaxWiseFile",
      is_ignore: this.vedio_is_ignore,
    });
    const blob = new Blob([responseContent], {
      type: "text/plain;charset=utf-8",
    });

    // 使用 FileSaver.js 保存 Blob 对象为文件
    fileSaver(blob, "音频超大资源.txt");
  }
  public inputValue2 = "";
  public inputValue3 = "";
  public big_page = 1;
  public big_size = 10;
  public video_page = 1;
  public video_size = 10;
  public pickChange2() {
    this.thread_trend_loading = true;
    this.thread_trend_api();
  }
  public max_table = [];
  public max_total = 0;
  public vedio_table = [];
  public vedio_total = 0;
  public async table_thread_max_api() {
    let data = await dispatchPkgResourceAbnormalList(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest_thread_old),
      page: this.big_page,
      size: this.big_size,

      search: this.inputValue2,
      type: "MaxFile",
      is_ignore: this.big_is_ignore,
    });
    data.results.forEach((v) => {
      if (v.is_ignore) {
        v.check = true;
      } else {
        v.check = false;
      }
    });
    this.max_table = data.results;
    this.max_total = data.count;
    this.thread_max_loading = false;
  }
  public maxChange(type) {
    this.thread_max_loading = true;
    if (type) {
      this.big_page = 1;
    }
    this.table_thread_max_api();
  }
  public thread_trend_loading = false;
  public thread_max_loading = false;
  public thread_vedio_loading = false;
  public videoChange(type) {
    this.thread_vedio_loading = true;
    if (type) {
      this.video_page = 1;
    }
    this.table_thread_video_api();
  }
  public async table_thread_video_api() {
    let data = await dispatchPkgResourceAbnormalList(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest_thread_old),
      page: this.video_page,
      size: this.video_size,

      search: this.inputValue3,
      type: "MaxWiseFile",
      is_ignore: this.vedio_is_ignore,
    });
    data.results.forEach((v) => {
      if (v.is_ignore) {
        v.check = true;
      } else {
        v.check = false;
      }
    });
    this.vedio_table = data.results;
    this.vedio_total = data.count;
    this.thread_vedio_loading = false;
  }
  public get pkgAsset() {
    return readGetPkgAssetStack(store);
  }
  public second_chart = false;
  public second_table = false;
  public get mapStructStack() {
    return readGetPkgMapStructStack(store);
  }
  public downloadFile(row) {
    const fileUrl = row.url; // 替换为您要下载的文件的实际路径
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = ""; // 您可以设置一个文件名，例如：link.download = "myfile.extension";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  public get treeData() {
    let list = readGetPkgStructStack(store);
    // console.log(list);
    list.forEach((v, index) => {
      if (index == 0) {
        v.id = 1;
      } else {
        v.id = 2;
      }
    });
    return list;
  }
  public vedio_is_ignore = "0";
  public big_is_ignore = "0";
  public expandedKeys = [];

  public get structTrendData() {
    return readGetPkgStructTrend(store)?.trend_data;
  }
  public get structMapTrendData() {
    return readGetPkgMapStructTrend(store);
  }
  public async thread_trend_api() {
    await dispatchAbnormalTrend(store, {
      project: this.localProject,
      start:
        this.form.thireadPick != null && this.form.thireadPick.length > 0
          ? dateConversion(this.form.thireadPick[0]).split(" ")[0]
          : "",
      end:
        this.form.thireadPick != null && this.form.thireadPick.length > 0
          ? dateConversion(this.form.thireadPick[1]).split(" ")[0]
          : "",
    });
    this.drawThreadTrend();
    this.thread_trend_loading = false;
  }
  public pkg_page = 1;
  public pkg_size = 10;
  public created_agin_list = [];
  public async pkgChange(type) {
    if (type) {
      this.pkg_page = 1;
    }
    await dispatchPkgAssetStack(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest_old),
      is_ignore: this.pkg_is_ignore,
      filename: this.type,
      page: this.pkg_page,
      size: this.pkg_size,
      // id_test: 65653,
    });
    this.submit();
  }
  public async handleClick() {
    if (!this.created_agin_list.includes("second")) {
      if (this.activeName === "second") {
        this.second_table = true;
        this.second_chart = true;
        this.form.dateOld = readGetPkgResourceDate(store)[0].date;
        await dispatchPkgResourceListOld(store, {
          project: this.localProject,
          date: this.form.dateOld,
          // device_id: Number(this.form.device),
          // scene_id: Number(this.form.scene),
        });

        // console.log(readGetPkgResourceListOld(store))
        this.form.idTest_old = readGetPkgResourceListOld(store)[0].id_test;

        this.pkg_is_ignore = "0";
        await dispatchPkgAssetType(store, {
          project: this.localProject,
          id_test: Number(this.form.idTest_old),
        });
        this.type = this.pkg_type[0].type;
        await dispatchPkgAssetStack(store, {
          project: this.localProject,
          id_test: Number(this.form.idTest_old),
          is_ignore: this.pkg_is_ignore,
          filename: this.type,
          page: this.pkg_page,
          size: this.pkg_size,
          // id_test: 65653,
        });
        this.second_table = false;
        this.form.secondPick = "";
        await dispatchPkgAssetTrend(store, {
          project: this.localProject,
          start: "",
          end: "",
        });

        // console.log(readGetPkgAssetStack(store));
        // console.log(this.secondTrendData);
        this.drawSecondTrend();
        this.second_chart = false;
        // this.merge == true;
        // this.changeList = [];
        // this.num = -1;
        // this.inputColor = "inputWhite";
        // this.pkgAsset.forEach((v) => {
        //   (this.$refs.table as any).toggleRowExpansion(v, false);
        //   document.getElementById(v.id).style.backgroundColor = "";
        // });
        this.created_agin_list.push(this.activeName);
      }
    }
    if (!this.created_agin_list.includes("thired")) {
      if (this.activeName === "thired") {
        this.thread_trend_loading = true;
        this.thread_max_loading = true;
        this.thread_vedio_loading = true;
        this.form.date_thired_old = readGetPkgResourceDate(store)[0].date;
        await dispatchPkgResourceListThreadOld(store, {
          project: this.localProject,
          date: this.form.date_thired_old,
          // device_id: Number(this.form.device),
          // scene_id: Number(this.form.scene),
        });

        // console.log(readGetPkgResourceListOld(store))
        this.form.idTest_thread_old = readGetPkgResourceListThreadOld(
          store
        )[0].id_test;
        this.thread_trend_api();
        this.table_thread_max_api();
        this.table_thread_video_api();

        this.created_agin_list.push(this.activeName);
      }
    }
  }
  public loading = false;
  public loading1 = false;
  public trendLoading = false;
  public tableLoading = false;
  public size = 10;
  public async handleCurrentChange() {
    this.loading1 = true;
    await dispatchPkgTypeTable(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
      serch: "",
      page: this.currentPage,
      size: this.size,
    });
    this.loading1 = false;
  }
  public num1 = -1;
  public expanded() {
    const els = document.getElementsByClassName(
      "el-table__expand-icon el-table__expand-icon--expanded"
    );
    console.log(els);
    this.$nextTick(() => {
      (els[0] as any)?.click();
    });
  }
  // public look(check,data){
  //  let c=false
  //   c=!c
  //      console.log(c)
  // }
  public num = 0;
  public trendList = [];
  public id_row = [];
  public async look(row, edit, data) {
    this.trendLoading = true;
    row.check = !row.check;

    if (row.check == true) {
      this.trendList.push(row.name);
      this.id_row.push(row.depth);
    } else {
      this.trendList.forEach((v, index) => {
        if (v === row.name) {
          this.num = index;
          this.trendList.splice(this.num, 1);
          this.id_row.splice(this.num, 1);
        }
      });
    }
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.form.pick !== null) {
      startTimeAll = dateConversion(this.form.pick[0]);
      endTimeAll = this.formatDate(this.form.pick[1], "yyyy-MM-dd 23:59:59");
    }

    startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    if (this.form.pick == null) {
      startTimeAll = "";
      endTimeAll = "";
    }

    await dispatchPkgResourceTrend(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
      names: this.trendList,
      id_row: this.id_row,
      start: startTimeAll,
      end: endTimeAll,
    });
    await this.drawTrend();
    this.trendLoading = false;
  }
  public async onSearch() {
    this.currentPage = 1;
    await dispatchPkgTypeTable(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
      serch: "",
      page: this.currentPage,
      size: this.size,
    });
  }
  public currentPage = 1;

  public getcolor(item, type) {
    let leftColor = "";
    let rightColor = "";

    if (item === type) {
      leftColor = 100 + "%";
      rightColor = 0 + "%";
    }
    if (item > type) {
      leftColor = 100 + "%";
    } else if (item < type) {
      leftColor = (item / type) * 100 + "%";
      rightColor = 100 - (item / type) * 100 + "%";
    }

    return [leftColor, rightColor];
  }
  public sizeCompany(item) {
    if (String(item) != "") {
      if (Number(item) < 1024) {
        return String(item) + "B";
      }
      if (Number(item) >= 1024 && Number(item) < 1024 * 1024) {
        return (Number(item) / 1024).toFixed(1) + "KB";
      }
      if (Number(item) >= 1024 * 1024 && Number(item) < 1024 * 1024 * 1024) {
        return (Number(item) / 1024 / 1024).toFixed(1) + "MB";
      }
      if (Number(item) >= 1024 * 1024 * 1024) {
        return (Number(item) / 1024 / 1024 / 1024).toFixed(1) + "GB";
      }
    } else {
      return "";
    }
  }
  public inputColor = "";
  public changeList = [];
  public async submit() {
    this.pkgAsset?.results.forEach((v) => {
      document.getElementById(v.name).style.color = "";
    });
    if (this.inputValue1 != "") {
      let list = this.pkgAsset?.results.filter((v) =>
        v.name.toUpperCase().includes(this.inputValue1.toUpperCase())
      );
      list.forEach((v) => {
        document.getElementById(v.name).style.color = "orange";
      });
    }
  }
  public get trendData() {
    return readGetPkgResourceTrend(store).trend_data;
  }
  public get secondTrendData() {
    return readGetPkgAssetTrend(store).trend_data;
  }
  public get threadTrendData() {
    return readGetPkgAbnormaTrend(store).trend_data;
  }

  public drawTrend() {
    let data: any = [];

    this.trendData.name_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.trendData as any).series[index],
      });
    });

    let performance_line: any = document.getElementById("trend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} MB",
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.trendData.game_version,
      },

      series: data,
    });
  }
  public drawSecondTrend() {
    let data: any = [];

    this.secondTrendData?.type_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.secondTrendData as any).series[index],
      });
    });

    let performance_line: any = document.getElementById("secondtrend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        // axisLabel: {
        //   formatter: "{value} MB",
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.secondTrendData?.game_version,
      },

      series: data,
    });
  }
  public async tableChange_thread(item) {
    this.thread_trend_loading = true;
    this.thread_max_loading = true;
    this.thread_vedio_loading = true;
    this.inputValue2 = "";
    this.inputValue3 = "";
    this.big_page = 1;
    this.big_size = 10;
    this.video_page = 1;
    this.video_size = 10;
    this.form.thireadPick = [];
    if (item.includes("device")) {
      await dispatchPkgResourceListThreadOld(store, {
        project: this.localProject,
        date: this.form.date_thired_old,
        // device_id: Number(this.form.device),
        // scene_id: Number(this.form.scene),
      });
      this.form.idTest_thread_old = readGetPkgResourceListThreadOld(
        store
      )[0].id_test;
    }
    this.thread_trend_api();
    this.table_thread_max_api();
    this.table_thread_video_api();
  }
  public mapLoding = false;
  public drawThreadTrend() {
    let data: any = [];

    this.threadTrendData?.type_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.threadTrendData as any).series[index],
      });
    });

    let performance_line: any = document.getElementById("threadTrend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.threadTrendData?.game_version,
      },

      series: data,
    });
  }
  public b = "50%";
  public c = "50%";
  public map_size = 20;
  public map_page = 1;
  public drawModular() {
    // let cilData = this.cilcrt;

    let performance_line: any = document.getElementById("rate") as HTMLElement;
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      title: {
        text: "总大小" + this.sizeCompany(this.allsize),

        left: "center",
      },
      // backgroundColor: 'rgb(13, 13, 13)',
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          var str = "";
          //首先要看看params是怎样的数据结构，里面有什么内容;

          //对params进行操作
          return (
            params.data.name +
            ":" +
            this.sizeCompany(params.data.value) +
            "(" +
            params.percent +
            "%)"
          );
        },
      },

      series: [
        {
          type: "pie",
          radius: "80%",
          // center: ["50%", "50%"],
          data: this.rateData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: "{d}%",
                position: "inside",
                color: "#fff",
              },
              labelLine: { show: false },
            },
          },
        },
      ],
    });
  }
  public activeName = "first";
  public get details_list() {
    let list: any = [];
    list = [
      { label: "名称", prop: "name" },
      { label: "Count", prop: "count" },
      { label: "Size", prop: "size" },
    ];

    return list;
  }
  public resources_list = [
    { name: "All", value: "" },
    { name: "待优化", value: "0" },
    { name: "无需优化", value: "1" },
  ];
  public async putCheck(row, type) {
    await dispatchPutAabnormalResourceList(store, {
      project: this.localProject,
      id: row.id,
      is_ignore: row.check ? "1" : "0",
    });
    if (type == "max") {
      this.maxChange(false);
    } else {
      this.videoChange(false);
    }
  }
  public rateArray = [];
  public get rateData() {
    this.rateArray = [];
    let num = 0;
    readGetPkgResourceRate(store).forEach((v) => {
      num += v.size;
      this.rateArray.push({ name: v.name, value: v.size });
    });

    return this.rateArray;
  }
  public async mapChange() {
    (this.map_page = 1), (this.map_size = 20);
    this.mapLoding = true;
    await dispatchPkgMapStructStack(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
      filename: this.mapFile,
    });
    if (this.mapFile) {
      await dispatchPkgMapStructStackList(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
        filename: this.mapFile,
      });
    }
    this.mapLoding = false;
    await dispatchPkgMapStructTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      filename: this.mapFile,
    });
    this.drawMapStruct();
  }
  public formatDate(date, fmt) {
    if (!date) {
      return "";
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }
    return fmt;
  }
  public padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
  public pkg_is_ignore = "0";
  public async pickChange() {
    this.trendLoading = true;
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.form.pick !== null) {
      startTimeAll = dateConversion(this.form.pick[0]);
      endTimeAll = this.formatDate(this.form.pick[1], "yyyy-MM-dd 23:59:59");
    }

    startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    if (this.form.pick == null) {
      startTimeAll = "";
      endTimeAll = "";
    }

    await dispatchPkgResourceTrend(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
      names: this.trendList,
      id_row: this.id_row,
      start: startTimeAll,
      end: endTimeAll,
    });
    await this.drawTrend();
    this.trendLoading = false;
    await dispatchPkgStructTrend(store, {
      project: this.localProject,
      start: startTimeAll,
      end: endTimeAll,
    });
    await dispatchPkgMapStructTrend(store, {
      project: this.localProject,
      start: startTimeAll,
      end: endTimeAll,
      filename: this.mapFile,
    });
    this.drawStruct();
    this.drawMapStruct();
  }

  public async pickChange1() {
    let startTimeAll = "";
    let endTimeAll = "";
    this.second_chart = true;
    if (this.form.secondPick !== null) {
      startTimeAll = dateConversion(this.form.secondPick[0]);
      endTimeAll = this.formatDate(
        this.form.secondPick[1],
        "yyyy-MM-dd 23:59:59"
      );
    }

    startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    if (this.form.secondPick == null) {
      startTimeAll = "";
      endTimeAll = "";
    }

    await dispatchPkgAssetTrend(store, {
      project: this.localProject,

      start: startTimeAll,
      end: endTimeAll,
    });
    await this.drawSecondTrend();
    this.second_chart = false;
  }
  public async tableChange(item) {
    for (let v of item) {
      // if (v === "device") {
      //   await dispatchPkgResourceDevice(store, {
      //     project: this.localProject,
      //     date: this.form.date,
      //   });
      //   this.form.device = readGetPkgResourceDevice(store)[0].device_id;
      // }
      // if (v === "scene") {
      //   await dispatchPkgResourceScenes(store, {
      //     project: this.localProject,
      //     date: this.form.date,
      //     device_id: Number(this.form.device),
      //   });
      //   this.form.scene = readGetPkgResourceScene(store)[0].id;
      // }
      if (v === "idTest") {
        if (this.activeName == "first") {
          await dispatchPkgResourceList(store, {
            project: this.localProject,
            date: this.form.date,
            // device_id: Number(this.form.device),
            // scene_id: Number(this.form.scene),
          });
          this.form.idTest = readGetPkgResourceList(store)[0].id_test;
        } else {
          await dispatchPkgResourceListOld(store, {
            project: this.localProject,
            date: this.form.dateOld,
            // device_id: Number(this.form.device),
            // scene_id: Number(this.form.scene),
          });
          this.form.idTest_old = readGetPkgResourceListOld(store)[0].id_test;
        }
      }
    }
    if (this.activeName == "first") {
      this.currentPage = 1;
      (this.map_page = 1), (this.map_size = 20);
      this.loading = true;
      this.loading1 = true;
      this.tableLoading = true;
      this.trendLoading = true;
      this.mapLoding = true;
      await dispatchPkgResourceSum(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
      });
      await dispatchPkgMapStructStackOption(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
      });
      this.mapFile =
        this.map_options.length > 0 ? this.map_options[0].filename : "";
      await dispatchPkgMapStructStack(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
        filename: this.mapFile,
      });
      if (this.mapFile) {
        await dispatchPkgMapStructStackList(store, {
          project: this.localProject,
          id_test: Number(this.form.idTest),
          filename: this.mapFile,
        });
      }
      this.mapLoding = false;
      await dispatchPkgStructStack(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
      });
      this.expandedKeys = [1, 2];
      this.allsize = readGetPkgResourceSum(store);
      await dispatchPkgTypeTable(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
        serch: "",
        page: 1,
        size: 10,
      });
      await dispatchPkgTypeRate(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
      });
      await this.drawModular();
      this.loading = false;
      this.loading1 = false;
      await dispatchPkgResourceStack(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
      });
      // (this.$refs.leftTable as any).toggleRowExpansion(
      //   readGetPkgResourceStack(store).func_list?.new[0],
      //   true
      // );
      this.allTypeSize = readGetPkgResourceStack(store).func_list.new[0]?.size;
      this.trendList = [];
      this.id_row = [];
      this.times = 0;
      this.trendList.push(
        readGetPkgResourceStack(store).func_list.new[0]?.name
      );
      this.id_row.push(readGetPkgResourceStack(store).func_list.new[0]?.depth);

      // this.trendList = [];
      // // this.id_row=[]
      // this.trendList.push(readGetPkgResourceStack(store).func_list.new[0].name);
      // this.id_row.push(readGetPkgResourceStack(store).func_list.new[0].depth);
      let startTimeAll = "";
      let endTimeAll = "";
      if (this.form.pick !== null) {
        startTimeAll = dateConversion(this.form.pick[0]);
        endTimeAll = this.formatDate(this.form.pick[1], "yyyy-MM-dd 23:59:59");
      }

      startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
      endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
      if (this.form.pick == null) {
        startTimeAll = "";
        endTimeAll = "";
      }
      this.testShow = false;
      await dispatchPkgResourceTrend(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
        names: this.trendList,
        id_row: this.id_row,
        start: startTimeAll,
        end: endTimeAll,
      });
      this.testShow = true;

      await this.drawTrend();

      this.tableLoading = false;
      await dispatchPkgStructTrend(store, {
        project: this.localProject,
        start: startTimeAll,
        end: endTimeAll,
      });
      await dispatchPkgMapStructTrend(store, {
        project: this.localProject,
        start: startTimeAll,
        end: endTimeAll,
        filename: this.mapFile,
      });
      this.drawStruct();
      this.drawMapStruct();

      if (this.testShow == true) {
        (this.$refs.leftTable as any).toggleRowExpansion(
          readGetPkgResourceStack(store).func_list?.new[0],
          true
        );
        this.$nextTick(() => {
          this.expanded();
        });
      }
      this.trendLoading = false;
    } else {
      this.second_table = true;
      // await dispatchPkgAssetStack(store, {
      //   project: this.localProject,
      //   id_test: Number(this.form.idTest_old),
      //   // id_test: 65653,
      // });
      await dispatchPkgAssetType(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest_old),
      });
      this.type = this.pkg_type[0].type;

      this.pkg_is_ignore = "0";
      this.pkgChange(true);

      this.second_table = false;
    }
    // await dispatchPkgResourceSum(store, {
    //   project: this.localProject,
    //   id_test: Number(this.form.idTest),
    // });
    // this.allsize = readGetPkgResourceSum(store);
    // await dispatchPkgTypeTable(store, {
    //   project: this.localProject,
    //   id_test: Number(this.form.idTest),
    //   serch: "",
    //   page: 1,
    //   size: 10,
    // });
    // await dispatchPkgTypeRate(store, {
    //   project: this.localProject,
    //   id_test: Number(this.form.idTest),
    // });
    // await this.drawModular();
    // this.loading = false;
    // this.loading1 = false;
    // await dispatchPkgResourceStack(store, {
    //   project: this.localProject,
    //   id_test: Number(this.form.idTest),
    // });
    // (this.$refs.leftTable as any).toggleRowExpansion(
    //   readGetPkgResourceStack(store).func_list?.new[0],
    //   true
    // );
    // this.allTypeSize = readGetPkgResourceStack(store).func_list.new[0].size;

    // this.trendList = [];
    // this.trendList.push(readGetPkgResourceStack(store).func_list.new[0].name);
    // this.id_row.push(readGetPkgResourceStack(store).func_list.new[0].depth);
    // let startTimeAll = "";
    // let endTimeAll = "";
    // if (this.form.pick !== null) {
    //   startTimeAll = dateConversion(this.form.pick[0]);
    //   endTimeAll = this.formatDate(this.form.pick[1], "yyyy-MM-dd 23:59:59");
    // }

    // startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    // endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    // if (this.form.pick == null) {
    //   startTimeAll = "";
    //   endTimeAll = "";
    // }

    // await dispatchPkgResourceTrend(store, {
    //   project: this.localProject,
    //   id_test: Number(this.form.idTest),
    //   names: this.trendList,
    //   id_row: this.id_row,
    //   start: startTimeAll,
    //   end: endTimeAll,
    // });
    // await this.expanded();
    // await this.drawTrend();
    // this.tableLoading = false;
    // this.trendLoading = false;
  }
  public testShow = true;
  public inputValue1 = "";
  public inputColor1 = "";
  public mounList = [];
  public drawStruct() {
    let data: any = [];

    (this.structTrendData as any)?.name_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.structTrendData as any).series[index],
      });
    });

    let performance_line: any = document.getElementById("struct");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} MB",
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: (this.structTrendData as any)?.game_version,
      },

      series: data,
    });
  }
  public drawMapStruct() {
    let data: any = [];

    (this.structMapTrendData as any)[this.mapFile]?.name_list.forEach(
      (v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: (this.structMapTrendData as any)[this.mapFile].series[index],
        });
      }
    );

    let performance_line: any = document.getElementById("structMap");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} MB",
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: (this.structMapTrendData as any)[this.mapFile]?.game_version,
      },

      series: data,
    });
  }
  public get map_options() {
    return readGetPkgMapStructStackOption(store);
  }
  public get mapList() {
    let list = readGetPkgMapStructStackList(store);
    let data = [];
    list.forEach((v) => {
      data.push({ name: v });
    });
    return data;
  }
  public mapFile = "";
  public async mounted() {
    this.loading = true;
    this.mapLoding = true;
    this.loading1 = true;
    this.tableLoading = true;
    this.trendLoading = true;
    await dispatchPkgResourceDate(store, {
      project: this.localProject,
    });
    this.form.date = readGetPkgResourceDate(store)[0].date;
    // await dispatchPkgResourceDevice(store, {
    //   project: this.localProject,
    //   date: this.form.date,
    // });
    // this.form.device = readGetPkgResourceDevice(store)[0].device_id;
    // await dispatchPkgResourceScenes(store, {
    //   project: this.localProject,
    //   date: this.form.date,
    //   device_id: Number(this.form.device),
    // });
    // this.form.scene = readGetPkgResourceScene(store)[0].id;
    await dispatchPkgResourceList(store, {
      project: this.localProject,
      date: this.form.date,
      // device_id: Number(this.form.device),
      // scene_id: Number(this.form.scene),
    });
    this.form.idTest = readGetPkgResourceList(store)[0].id_test;

    await dispatchPkgTypeTable(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
      serch: "",
      page: 1,
      size: 10,
    });
    await dispatchPkgMapStructStackOption(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
    });
    this.mapFile =
      this.map_options.length > 0 ? this.map_options[0].filename : "";
    await dispatchPkgMapStructStack(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
      filename: this.mapFile,
    });
    if (this.mapFile) {
      await dispatchPkgMapStructStackList(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
        filename: this.mapFile,
      });
    }

    this.mapLoding = false;
    await dispatchPkgTypeRate(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
    });
    await dispatchPkgStructStack(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
    });

    this.expandedKeys = [1, 2];

    await dispatchPkgResourceSum(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
    });
    this.allsize = readGetPkgResourceSum(store);
    await this.drawModular();

    this.loading = false;
    this.loading1 = false;
    await dispatchPkgResourceStack(store, {
      project: this.localProject,
      id_test: Number(this.form.idTest),
    });
    if (readGetPkgResourceStack(store).func_list.new.length != 0) {
      (this.$refs.leftTable as any)?.toggleRowExpansion(
        readGetPkgResourceStack(store).func_list?.new[0],
        true
      );

      this.allTypeSize = readGetPkgResourceStack(store).func_list.new[0].size;
      this.trendList.push(readGetPkgResourceStack(store).func_list.new[0].name);
      this.id_row.push(readGetPkgResourceStack(store).func_list.new[0].depth);

      // 自动触发 重点
      await this.expanded();
    }

    await dispatchPkgStructTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
    });
    await dispatchPkgMapStructTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      filename: this.mapFile,
    });
    this.drawStruct();
    this.drawMapStruct();
    //  await dispatchPkgResourceTrend(store, {
    //   project: this.localProject,
    //   id_test: Number(this.form.idTest),
    //   names: this.trendList,
    //   id_row: this.id_row,
    //   start: "",
    //   end: "",
    // });
    // await this.drawTrend();
    this.tableLoading = false;
    this.trendLoading = false;
  }
  public allTypeSize = 0;
  public allsize = 0;
  public get dateOptions() {
    return readGetPkgResourceDate(store);
  }
  public get deviceOptions() {
    return readGetPkgResourceDevice(store);
  }
  public get sceneOptions() {
    return readGetPkgResourceScene(store);
  }
  public get listOptions() {
    return readGetPkgResourceList(store);
  }
  public get listOptions_old() {
    return readGetPkgResourceListOld(store);
  }
  public get listOptions_thread_old() {
    return readGetPkgResourceListThreadOld(store);
  }
  public times = 0;
  public get stackTabel() {
    readGetPkgResourceStack(store).func_list?.new?.forEach((v) => {
      v.id = v.id_row;
      v.check = true;
    });
    return readGetPkgResourceStack(store);
  }
  public async load(
    row: any,
    treeNode: unknown,
    resolve: (date: any[]) => void
  ) {
    // }
    if (readGetPkgResourceStack(store).func_list.new.length != 0) {
      await dispatchPkgResourceStackOld(store, {
        project: this.localProject,
        id_test: Number(this.form.idTest),
        id_row: row.id_row,
        depth: row.depth,
      });
      this.times++;
      let childrenListArray = readGetPkgResourceStackOld(store);
      await childrenListArray?.func_list?.new.forEach((v, index) => {
        v.id = v.id_row;
        if (this.times == 1) {
          if (index <= 4) {
            this.id_row.push(v.depth);
            this.trendList.push(v.name);
            v.check = true;
          } else {
            v.check = false;
          }
        } else {
          v.check = false;
        }
      });
      if (this.times == 1) {
        await dispatchPkgResourceTrend(store, {
          project: this.localProject,
          id_test: Number(this.form.idTest),
          names: this.trendList,
          id_row: this.id_row,
          start: "",
          end: "",
        });
        await this.drawTrend();
      }

      // if(childrenListArray?.depth===1){
      //     await dispatchPkgResourceTrend(store,{
      //     project: this.localProject,
      //   id_test: Number(this.form.idTest),
      //   names:this.trendList
      //  })
      //   await this.drawTrend()
      // }
      await setTimeout(() => {
        resolve(childrenListArray?.func_list?.new);
      }, 1000);
    }
  }

  public get typeList() {
    return readGetPkgResourceTable(store);
  }
  public tableRowClassName(row) {
    return { background: "#0D0D0D", color: "#fff" };
  }
  public tableRowClassName1(row) {
    // console.log(row);
    if (row.row.remark == "E") {
      return { background: "#FDF4EC" };
    }
  }
}
